module.exports = __webpack_public_path__ + "img/a4.22d4a69d.jpg";